class FAQ {
  constructor() {
    const anchors = [].slice.call(
      document.querySelectorAll('[data-anchor]')
    );
    
    if (anchors.length > 0) {
      anchors.forEach(anchor => {
        ['click', 'keypress'].forEach(event => {
          anchor.addEventListener(event, e => {
            const key = e.which || e.keyCode;
            if (key === 13 || e.type === 'click') {
              this.handleAnchor(anchor.dataset.anchor);
            }
          })
        })
      })
    }
  }

  handleAnchor = (target) => {
    const currentTarget = document.getElementById(target);
    const yPosition = currentTarget.getBoundingClientRect().top + window.pageYOffset - 100;
  
    window.scrollTo({behavior: 'smooth', top: yPosition,});
  };
}

const faqInit = {
  init() {
    // if element exists init this class
    const faqElem = [].slice.call(
      document.querySelectorAll('.faq')
    );
    if (faqElem.length > 0) {
      new FAQ();
    }
  }
};

export default faqInit;
